var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "page" } }, [
      _c("div", { attrs: { id: "container" } }, [
        _c("div", { staticClass: "left", attrs: { id: "foot" } }, [
          _c("div", { attrs: { id: "f1" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "f2" } }),
          _vm._v(" "),
          _c("div", { staticClass: "first", attrs: { id: "leg1" } }, [
            _c("div", { staticClass: "next1", attrs: { id: "leg1" } }, [
              _c("div", { staticClass: "next1", attrs: { id: "leg1" } }, [
                _c("div", { staticClass: "next1", attrs: { id: "leg1" } }, [
                  _c("div", { staticClass: "next1", attrs: { id: "leg1" } }),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right", attrs: { id: "foot" } }, [
          _c("div", { attrs: { id: "f1" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "f2" } }),
          _vm._v(" "),
          _c("div", { staticClass: "first", attrs: { id: "leg2" } }, [
            _c("div", { staticClass: "next2", attrs: { id: "leg2" } }, [
              _c("div", { staticClass: "next2", attrs: { id: "leg2" } }, [
                _c("div", { staticClass: "next2", attrs: { id: "leg2" } }, [
                  _c("div", { staticClass: "next2", attrs: { id: "leg2" } }),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "body" } }, [
          _c("div", { attrs: { id: "b1" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "b2" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "b3" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "head" } }, [
            _c("div", { attrs: { id: "h1" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "h2" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "h3" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "h4" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "h5" } }, [_c("span")]),
            _vm._v(" "),
            _c("div", { attrs: { id: "eyes" } }, [
              _c("div", { attrs: { id: "e" } }, [
                _c("div", { attrs: { id: "e1" } }, [
                  _c("div", { attrs: { id: "eye" } }),
                  _vm._v(" "),
                  _c("span"),
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "e2" } }, [
                  _c("div", { attrs: { id: "eye" } }),
                  _vm._v(" "),
                  _c("span"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "mouth" } }, [
              _c("span"),
              _vm._v(" "),
              _c("span"),
              _vm._v(" "),
              _c("span"),
              _vm._v(" "),
              _c("span"),
              _vm._v(" "),
              _c("span"),
              _vm._v(" "),
              _c("div", { attrs: { id: "m1" } }),
              _vm._v(" "),
              _c("div", { attrs: { id: "m2" } }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "b4" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "b5" } }, [
            _c("div", { attrs: { id: "b51" } }, [
              _c("div", { attrs: { id: "b51" } }, [
                _c("div", { attrs: { id: "b51" } }, [
                  _c("div", { attrs: { id: "b51" } }, [
                    _c("div", { attrs: { id: "ab" } }, [
                      _c("div", { attrs: { id: "a1" } }),
                      _vm._v(" "),
                      _c("div", { attrs: { id: "a2" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "a31", attrs: { id: "a3" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "a32", attrs: { id: "a3" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "a33", attrs: { id: "a3" } }),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "b6" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "b7" } }, [
            _c("div", { attrs: { id: "b71" } }, [
              _c("div", { attrs: { id: "b71" } }, [
                _c("div", { attrs: { id: "b71" } }, [
                  _c("div", { attrs: { id: "b71" } }, [
                    _c("div", { attrs: { id: "ac" } }, [
                      _c("div", { attrs: { id: "a1" } }),
                      _vm._v(" "),
                      _c("div", { attrs: { id: "a2" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "a31", attrs: { id: "a3" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "a32", attrs: { id: "a3" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "a33", attrs: { id: "a3" } }),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "b8" } }, [_c("span")]),
          _vm._v(" "),
          _c("div", { attrs: { id: "b9" } }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }